const checkoutBtn = document.querySelector("#CheckOut");

export async function createCartAndCheckout(e) {
    // e.preventDefault();

    const customerEmail = document.querySelector("#customer-email")?.value;
    const storedAISuggestions = getStoredAISuggestions();
    const { cartItems, AISuggestionsMetricsArr } = processCartItems(storedAISuggestions?.skuList);
    const userToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6NCwiZW1haWwiOiJlbW1hbnVlbC5vanVrd3VAdGhlbG9vcC5wdCIsInJvbGUiOjIsImlhdCI6MTc1OTE2MzM4MSwiZXhwIjoxNzYxNTgyNTgxfQ.0C7TAkGVHHY_wqFLEhe9Pw_IDPjKo7v5D8_3nolmF3g";
    
    // console.log("Checkout here", {cartItems, AISuggestionsMetricsArr});

    // Send metrics if any AI suggested products are in cart
    if (AISuggestionsMetricsArr.length > 0) {

      const metricsPayload = {
        "email": customerEmail,
        "purchases": AISuggestionsMetricsArr
      };
      const metricsRes = await fetch(`https://sonae-ai-backend.production.theloop.tech/processing-metrics/${storedAISuggestions.jobId}/purchase-analysis`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          Authorization: `Bearer ${userToken}`
        },
        body: JSON.stringify(metricsPayload)
      });
    }

    // Create cart and redirect to checkout
    const createCartRes = await fetch(`https://bazaar-note-online-loja.myshopify.com/api/2024-10/graphql.json`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Shopify-Storefront-Access-Token": `95ddf75a34443ce885a97a70d7cea283`,
        },
        body: JSON.stringify({
          "query": "mutation cartCreate($input: CartInput) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }",
          "variables": {
            "input": {
                ...(customerEmail ? {"buyerIdentity": {"email": customerEmail}} : {}),
                "lines": cartItems,
                "attributes": [
                  {
                    "key": "cart_origin_store",
                    "value": "EscolaNote"
                  },
                  ...(storedAISuggestions?.jobId ? [{
                    "key": "suggestions_id",
                    "value": storedAISuggestions.jobId
                  }] : [])
                ],
            }
          }
        })
    });
    const resJson = await createCartRes.json();

    // console.log({resJson});
    if (resJson){
        if (storedAISuggestions?.jobId) {
            // Clear previous suggestions
            localStorage.removeItem("ai_suggested_products");
        }
        console.log({cartItems})
        location.assign(`${resJson.data.cartCreate.cart.checkoutUrl}`);
    }

}

checkoutBtn && checkoutBtn.addEventListener("click", createCartAndCheckout);

function processCartItems(storedAISuggestions) {
  const AISuggestionsMetricsArr = [];
  const currentDate = new Date().toISOString();

  const cartItems = Array.from(document.querySelectorAll('[data-js-cart-item]')).map((item) => {
      const sku = item.dataset.sku;
      const isItemFromAISuggestions = storedAISuggestions && sku in storedAISuggestions;
      
      if (isItemFromAISuggestions) {
        AISuggestionsMetricsArr.push({
            "originalItemText": storedAISuggestions[sku],
            "purchasedSku": +sku,
            "quantity": +item.dataset.qty,
            "purchaseDate": currentDate
        });
      }

      return {
          quantity: +item.dataset.qty,
          merchandiseId: item.dataset.sourceVariantId,
          ...(isItemFromAISuggestions ? 
            {
              attributes: [
                {
                  key: "Lista_AI-EscolaNote",
                  value: storedAISuggestions[sku]
                }
              ]
            } 
            : {}
          )
      };
  });

  return { cartItems, AISuggestionsMetricsArr };
}

function getStoredAISuggestions() {
  try {
      // Check for existing suggestions
      const lastSuggestions = localStorage.getItem("ai_suggested_products");
      let AISuggestedProductsInfo = lastSuggestions ? JSON.parse(lastSuggestions) : {};

      if (
          typeof AISuggestedProductsInfo == "object" &&
          Object.values(AISuggestedProductsInfo).length > 0
      ) {

          return {
            skuList: AISuggestedProductsInfo.skuList || {},
            jobId: AISuggestedProductsInfo.jobId || null,
          };
      } else {
        return null;
      }
  } catch (error) {
      console.log("LocalStorage error: ", error?.message);
      return null;
  }
  
}